import gql from 'graphql-tag';

const cancelGuaranteePurchaseMutation = gql`
  mutation cancelGuaranteePurchase(
    $cancelInput: CancelGuaranteePurchaseInput!
  ) {
    cancelGuaranteePurchase(input: $cancelInput) {
      success
      errors
    }
  }
`;

export default cancelGuaranteePurchaseMutation;
